module.exports = __webpack_public_path__ + "ni.e1dfe9bd73a46209f258.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/ni.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/ni.svg
// module chunks = styles